import { useEffect, useState } from 'react';
import { Container, Header } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { EPICS_PATH_CONTINUE } from 'volto-epics-addon/constants';
import { TASK_LIVE_JOBS_VIEW } from 'volto-m4-theme-addon/constants';
import { useTaskPoll } from 'volto-epics-addon/helpers';
import { useIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
  liveWaitForProcess: {
    id: 'liveWaitForProcess',
    defaultMessage: 'Please wait while your data is being processed...',
  },
  mustLoginFirst: {
    id: 'mustLoginFirst',
    defaultMessage: 'You must log in first.',
  },
});

const Page = () => {
  const history = useHistory();
  const task = useTaskPoll(1000, TASK_LIVE_JOBS_VIEW);
  const [mediaPeageUid, setMediaPageUid] = useState('');
  const token = useSelector((state) => state.userSession.token);
  const intl = useIntl();

  const isAuthenticated = !!token;

  useEffect(() => {
    if (task) {
      if (mediaPeageUid === '') {
        setMediaPageUid(task.variables.mediaPageUid);
      }
      if (task?.completed === true) {
        history.push(EPICS_PATH_CONTINUE);
      }
    }
  }, [task, history, mediaPeageUid]);

  return isAuthenticated ? (
    <Container className="waitforjobs-view-container">
      <Header>{intl.formatMessage(messages.liveWaitForProcess)}</Header>
    </Container>
  ) : (
    <Container className="waitforjobs-view-container">
      <Header className="ui header">
        {intl.formatMessage(messages.mustLoginFirst)}
      </Header>
    </Container>
  );
};

export default Page;
